// extracted by mini-css-extract-plugin
export var autoSpacing = "ButtonGroup-module--auto-spacing--6806a";
export var centerAlign = "ButtonGroup-module--center-align--7b379";
export var group = "ButtonGroup-module--group--9f96a";
export var hideOnMobile = "ButtonGroup-module--hide-on-mobile--cae97";
export var leftAlign = "ButtonGroup-module--left-align--f4224";
export var lgSpacing = "ButtonGroup-module--lg-spacing--672fb";
export var mdSpacing = "ButtonGroup-module--md-spacing--0b906";
export var rightAlign = "ButtonGroup-module--right-align--e2d56";
export var stretch = "ButtonGroup-module--stretch--b5e8f";
export var xlSpacing = "ButtonGroup-module--xl-spacing--36283";